import { render, staticRenderFns } from "./Highlight.vue?vue&type=template&id=f6b89ec4&scoped=true&"
import script from "./Highlight.vue?vue&type=script&lang=js&"
export * from "./Highlight.vue?vue&type=script&lang=js&"
import style0 from "./Highlight.vue?vue&type=style&index=0&id=f6b89ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b89ec4",
  null
  
)

export default component.exports